import moment from "moment";

export default {
  methods: {
    navTo(page, params) {
      this.$router.push({ name: page, params });
    },
    formatDate(value) {
      return moment(value)
        .format("MMM DD, YYYY hh:mm A")
        .toUpperCase();
    },
    isProduction() {
      return window.location.hostname === "solarbase.arnergy.com";
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/global.js